import React from "react";
import { uri } from "../../../help/Api";
import { useEffect } from "react";
import BackdropScI from "../../../services/BackdropScI";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import ZatcaSettings from "./zatca-settings";
import LoadingPage from "../../../services/LoadingPage";
import { sto } from "../../../Context/InshData";
// import Safes from "./safes";

export default function ZatcaSettingsCon() {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `Zatca/GetCertificateSettings?branchId=${sto?.branchi}`
  } else {
    Urls = `Zatca/GetCertificateSettings?branchId=${sto?.branchi}&&?db_name=${sto?.db_name}`
  }
  const url = uri + Urls;

  const { data, fetching, fetchURL } = useFetchURL({
    ...{
      url,
    },
  });

  useEffect(() => {
    console.log("data  is", data);
  });

  if (fetching || !data) return <LoadingPage />;
  return (
    <ZatcaSettings
      {...{
        data,
        fetchURL,
      }}
    />
  );
}
